<template>
  <div>
    <!-- cover -->
    <div id="cover" class="w-screen h-screen fixed main-bg z-30" v-lazy-background :lazy-background="wedding.images[0].url">
      <div class="absolute bottom-0 right-0 left-0 text-white flex flex-col z-20"
        :class="isGuestExists ? 'h-full lg:h-4/5 justify-around' : 'h-full justify-center'">
        <div class="text-center">
          <h1 class="font-fair text-2xl lg:text-4xl mb-10">THE WEDDING OF</h1>
          <h1 class="font-great text-5xl lg:text-8xl">{{ `${wedding.wife_nickname} & ${wedding.husband_nickname}` }}
          </h1>
        </div>
        <div v-if="isGuestExists" class="items-center flex flex-col font-fair">
          <span class="mb-3 text-2xl lg:text-4xl font-semibold"> Hello, {{ wedding.guests[0].name }}</span>
          <span class="mb-5 text-lg lg:text-2xl font-fair">
            You are invited
          </span>
          <button class="thm2-btn max-w-max" @click="openInvitation">Buka Undangan</button>
        </div>
      </div>
    </div>
    <!-- cover end -->
    <div id="body" class="hidden">
      <div class="relative min-h-screen font-fair text-center surah-cover py-8 lg:bg-top lg:bg-cover"
        v-lazy-background :lazy-background="wedding.images[1] ? wedding.images[1].url : ''">
        <div class="relative z-10" data-aos="fade-up" data-aos-duration="2000">
          <h1 class="text-2xl lg:text-4xl italic font-bold" style="color: #D0A464;">The Promises</h1>
          <p class="text-xs lg:text-2xl w-4/5 mx-auto text-white my-5" v-html="wedding.surah_detail" />
          <h2 class="text-xs lg:text-2xl font-bold text-white">{{ wedding.surah }}</h2>
        </div>
      </div>

      <!-- person  -->
      <div id="person" class="relative bg-transparent -translate-y-10 z-10 font-fair">
        <div
          class=" person-cover overflow-hidden min-h-screen rounded-2xl relative py-10 px-5 flex flex-col justify-between lg:justify-around"
          v-lazy-background :lazy-background="wedding.images[2] ? wedding.images[2].url : ''">
          <div class="text-center relative z-20" data-aos="fade-up" data-aos-duration="500">
            <h1 class="text-lg lg:text-2xl italic font-bold mb-5" style="color: #D0A464">Assalamu’alaikum Wr.Wb</h1>
            <p class="text-xs lg:text-xl text-white">Dengan memohon Rahmat dan Ridho Allah SWT kami bermaksud untuk
              mengundang Bapak/Ibu/Saudara/i untuk menghadiri acara pernikahan putra – putri kami :</p>
          </div>
          <div class="text-white w-5/6 mx-auto relative z-20 font-fair flex flex-col gap-10" data-aos="fade-left"
            data-aos-duration="500">
            <div class="lg:mb-9 flex flex-col items-center lg:items-start lg:self-start">
              <div class="text-lg lg:text-5xl mb-4 text-center lg:text-right" style="color: #D0A464">{{ wedding.wife }}
              </div>
              <div class="text-xs lg:text-xl mb-4 text-center lg:text-left flex flex-col lg:flex-row"><span>Putri Bapak
                  {{ wedding.wife_father }}</span> <span class="hidden lg:block mx-2">{{ ' - ' }}</span> <span
                  class="lg:hidden">dan</span> <span>Ibu {{ wedding.wife_mother }}</span></div>
              <a v-if="wedding.wife_instagram" class="flex flex-row gap-4" :href="wedding.wife_instagram"
                target="_blank">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                  stroke="#D0A464">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.465 1.566C8.638 1.512 9.012 1.5 12 1.5C14.988 1.5 15.362 1.513 16.534 1.566C17.706 1.619 18.506 1.806 19.206 2.077C19.939 2.354 20.604 2.787 21.154 3.347C21.714 3.896 22.146 4.56 22.422 5.294C22.694 5.994 22.88 6.794 22.934 7.964C22.988 9.139 23 9.513 23 12.5C23 15.488 22.987 15.862 22.934 17.035C22.881 18.205 22.694 19.005 22.422 19.705C22.146 20.4391 21.7133 21.1042 21.154 21.654C20.604 22.214 19.939 22.646 19.206 22.922C18.506 23.194 17.706 23.38 16.536 23.434C15.362 23.488 14.988 23.5 12 23.5C9.012 23.5 8.638 23.487 7.465 23.434C6.295 23.381 5.495 23.194 4.795 22.922C4.06092 22.646 3.39582 22.2133 2.846 21.654C2.28638 21.1047 1.85331 20.4399 1.577 19.706C1.306 19.006 1.12 18.206 1.066 17.036C1.012 15.861 1 15.487 1 12.5C1 9.512 1.013 9.138 1.066 7.966C1.119 6.794 1.306 5.994 1.577 5.294C1.85372 4.56008 2.28712 3.89531 2.847 3.346C3.39604 2.7865 4.06047 2.35344 4.794 2.077C5.494 1.806 6.294 1.62 7.464 1.566H7.465ZM16.445 3.546C15.285 3.493 14.937 3.482 12 3.482C9.063 3.482 8.715 3.493 7.555 3.546C6.482 3.595 5.9 3.774 5.512 3.925C4.999 4.125 4.632 4.362 4.247 4.747C3.88205 5.10205 3.60118 5.53428 3.425 6.012C3.274 6.4 3.095 6.982 3.046 8.055C2.993 9.215 2.982 9.563 2.982 12.5C2.982 15.437 2.993 15.785 3.046 16.945C3.095 18.018 3.274 18.6 3.425 18.988C3.601 19.465 3.882 19.898 4.247 20.253C4.602 20.618 5.035 20.899 5.512 21.075C5.9 21.226 6.482 21.405 7.555 21.454C8.715 21.507 9.062 21.518 12 21.518C14.938 21.518 15.285 21.507 16.445 21.454C17.518 21.405 18.1 21.226 18.488 21.075C19.001 20.875 19.368 20.638 19.753 20.253C20.118 19.898 20.399 19.465 20.575 18.988C20.726 18.6 20.905 18.018 20.954 16.945C21.007 15.785 21.018 15.437 21.018 12.5C21.018 9.563 21.007 9.215 20.954 8.055C20.905 6.982 20.726 6.4 20.575 6.012C20.375 5.499 20.138 5.132 19.753 4.747C19.3979 4.38207 18.9657 4.10121 18.488 3.925C18.1 3.774 17.518 3.595 16.445 3.546ZM10.595 15.891C11.3797 16.2176 12.2534 16.2617 13.0669 16.0157C13.8805 15.7697 14.5834 15.2489 15.0556 14.5422C15.5278 13.8356 15.7401 12.9869 15.656 12.1411C15.572 11.2953 15.197 10.505 14.595 9.905C14.2112 9.52148 13.7472 9.22781 13.2363 9.04515C12.7255 8.86248 12.1804 8.79536 11.6405 8.84862C11.1006 8.90187 10.5792 9.07418 10.1138 9.35313C9.64845 9.63208 9.25074 10.0107 8.9493 10.4619C8.64786 10.913 8.45019 11.4253 8.37052 11.962C8.29084 12.4986 8.33115 13.0463 8.48854 13.5655C8.64593 14.0847 8.91648 14.5626 9.28072 14.9647C9.64496 15.3668 10.0938 15.6832 10.595 15.891ZM8.002 8.502C8.52702 7.97697 9.15032 7.5605 9.8363 7.27636C10.5223 6.99222 11.2575 6.84597 12 6.84597C12.7425 6.84597 13.4777 6.99222 14.1637 7.27636C14.8497 7.5605 15.473 7.97697 15.998 8.502C16.523 9.02702 16.9395 9.65032 17.2236 10.3363C17.5078 11.0223 17.654 11.7575 17.654 12.5C17.654 13.2425 17.5078 13.9777 17.2236 14.6637C16.9395 15.3497 16.523 15.973 15.998 16.498C14.9377 17.5583 13.4995 18.154 12 18.154C10.5005 18.154 9.06234 17.5583 8.002 16.498C6.94166 15.4377 6.34597 13.9995 6.34597 12.5C6.34597 11.0005 6.94166 9.56234 8.002 8.502ZM18.908 7.688C19.0381 7.56527 19.1423 7.41768 19.2143 7.25397C19.2863 7.09027 19.3248 6.91377 19.3274 6.73493C19.33 6.55609 19.2967 6.37855 19.2295 6.21281C19.1622 6.04707 19.0624 5.89651 18.936 5.77004C18.8095 5.64357 18.6589 5.54376 18.4932 5.47652C18.3275 5.40928 18.1499 5.37598 17.9711 5.37858C17.7922 5.38119 17.6157 5.41965 17.452 5.4917C17.2883 5.56374 17.1407 5.6679 17.018 5.798C16.7793 6.05103 16.6486 6.38712 16.6537 6.73493C16.6588 7.08274 16.7992 7.41488 17.0452 7.66084C17.2911 7.90681 17.6233 8.04723 17.9711 8.0523C18.3189 8.05737 18.655 7.92669 18.908 7.688Z"
                    fill="white" />
                </svg>
              </a>
            </div>
            <div class="border-b-2 border-white lg:border-b-0 w-2/5 mx-auto" data-aos="zoom-in" data-aos-duration="500">
            </div>
            <div class="lg:self-end flex flex-col items-center lg:items-start" data-aos="fade-right"
              data-aos-duration="500">
              <div class="text-lg lg:text-5xl mb-4 text-center lg:text-right" style="color: #D0A464">{{
                wedding.husband
              }}</div>
              <div class="text-xs lg:text-xl mb-4 text-center lg:text-left flex flex-col lg:flex-row"><span>Putra Bapak
                  {{ wedding.husband_father }}</span> <span class="hidden lg:block mx-2">{{ ' - ' }}</span> <span
                  class="lg:hidden">dan</span> <span>Ibu {{ wedding.husband_mother }}</span></div>
              <a v-if="wedding.husband_instagram" class="flex flex-row gap-4" :href="wedding.husband_instagram"
                target="_blank">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                  stroke="#D0A464">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.465 1.566C8.638 1.512 9.012 1.5 12 1.5C14.988 1.5 15.362 1.513 16.534 1.566C17.706 1.619 18.506 1.806 19.206 2.077C19.939 2.354 20.604 2.787 21.154 3.347C21.714 3.896 22.146 4.56 22.422 5.294C22.694 5.994 22.88 6.794 22.934 7.964C22.988 9.139 23 9.513 23 12.5C23 15.488 22.987 15.862 22.934 17.035C22.881 18.205 22.694 19.005 22.422 19.705C22.146 20.4391 21.7133 21.1042 21.154 21.654C20.604 22.214 19.939 22.646 19.206 22.922C18.506 23.194 17.706 23.38 16.536 23.434C15.362 23.488 14.988 23.5 12 23.5C9.012 23.5 8.638 23.487 7.465 23.434C6.295 23.381 5.495 23.194 4.795 22.922C4.06092 22.646 3.39582 22.2133 2.846 21.654C2.28638 21.1047 1.85331 20.4399 1.577 19.706C1.306 19.006 1.12 18.206 1.066 17.036C1.012 15.861 1 15.487 1 12.5C1 9.512 1.013 9.138 1.066 7.966C1.119 6.794 1.306 5.994 1.577 5.294C1.85372 4.56008 2.28712 3.89531 2.847 3.346C3.39604 2.7865 4.06047 2.35344 4.794 2.077C5.494 1.806 6.294 1.62 7.464 1.566H7.465ZM16.445 3.546C15.285 3.493 14.937 3.482 12 3.482C9.063 3.482 8.715 3.493 7.555 3.546C6.482 3.595 5.9 3.774 5.512 3.925C4.999 4.125 4.632 4.362 4.247 4.747C3.88205 5.10205 3.60118 5.53428 3.425 6.012C3.274 6.4 3.095 6.982 3.046 8.055C2.993 9.215 2.982 9.563 2.982 12.5C2.982 15.437 2.993 15.785 3.046 16.945C3.095 18.018 3.274 18.6 3.425 18.988C3.601 19.465 3.882 19.898 4.247 20.253C4.602 20.618 5.035 20.899 5.512 21.075C5.9 21.226 6.482 21.405 7.555 21.454C8.715 21.507 9.062 21.518 12 21.518C14.938 21.518 15.285 21.507 16.445 21.454C17.518 21.405 18.1 21.226 18.488 21.075C19.001 20.875 19.368 20.638 19.753 20.253C20.118 19.898 20.399 19.465 20.575 18.988C20.726 18.6 20.905 18.018 20.954 16.945C21.007 15.785 21.018 15.437 21.018 12.5C21.018 9.563 21.007 9.215 20.954 8.055C20.905 6.982 20.726 6.4 20.575 6.012C20.375 5.499 20.138 5.132 19.753 4.747C19.3979 4.38207 18.9657 4.10121 18.488 3.925C18.1 3.774 17.518 3.595 16.445 3.546ZM10.595 15.891C11.3797 16.2176 12.2534 16.2617 13.0669 16.0157C13.8805 15.7697 14.5834 15.2489 15.0556 14.5422C15.5278 13.8356 15.7401 12.9869 15.656 12.1411C15.572 11.2953 15.197 10.505 14.595 9.905C14.2112 9.52148 13.7472 9.22781 13.2363 9.04515C12.7255 8.86248 12.1804 8.79536 11.6405 8.84862C11.1006 8.90187 10.5792 9.07418 10.1138 9.35313C9.64845 9.63208 9.25074 10.0107 8.9493 10.4619C8.64786 10.913 8.45019 11.4253 8.37052 11.962C8.29084 12.4986 8.33115 13.0463 8.48854 13.5655C8.64593 14.0847 8.91648 14.5626 9.28072 14.9647C9.64496 15.3668 10.0938 15.6832 10.595 15.891ZM8.002 8.502C8.52702 7.97697 9.15032 7.5605 9.8363 7.27636C10.5223 6.99222 11.2575 6.84597 12 6.84597C12.7425 6.84597 13.4777 6.99222 14.1637 7.27636C14.8497 7.5605 15.473 7.97697 15.998 8.502C16.523 9.02702 16.9395 9.65032 17.2236 10.3363C17.5078 11.0223 17.654 11.7575 17.654 12.5C17.654 13.2425 17.5078 13.9777 17.2236 14.6637C16.9395 15.3497 16.523 15.973 15.998 16.498C14.9377 17.5583 13.4995 18.154 12 18.154C10.5005 18.154 9.06234 17.5583 8.002 16.498C6.94166 15.4377 6.34597 13.9995 6.34597 12.5C6.34597 11.0005 6.94166 9.56234 8.002 8.502ZM18.908 7.688C19.0381 7.56527 19.1423 7.41768 19.2143 7.25397C19.2863 7.09027 19.3248 6.91377 19.3274 6.73493C19.33 6.55609 19.2967 6.37855 19.2295 6.21281C19.1622 6.04707 19.0624 5.89651 18.936 5.77004C18.8095 5.64357 18.6589 5.54376 18.4932 5.47652C18.3275 5.40928 18.1499 5.37598 17.9711 5.37858C17.7922 5.38119 17.6157 5.41965 17.452 5.4917C17.2883 5.56374 17.1407 5.6679 17.018 5.798C16.7793 6.05103 16.6486 6.38712 16.6537 6.73493C16.6588 7.08274 16.7992 7.41488 17.0452 7.66084C17.2911 7.90681 17.6233 8.04723 17.9711 8.0523C18.3189 8.05737 18.655 7.92669 18.908 7.688Z"
                    fill="white" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- person end  -->

      <!-- event -->
      <div v-if="wedding.events" id="event" class="relative min-h-max font-fair pb-10">
        <img v-lazy-load src="~/assets/images/theme2/backdrop-1.svg"
          class="w-2/4 lg:w-auto absolute right-0 bottom-0 -z-10" alt="bc-1">
        <img v-lazy-load src="~/assets/images/theme2/backdrop-2.svg" class="w-2/4 lg:w-auto absolute left-0 top-0 -z-10"
          alt="bc-2">
        <img v-lazy-load src="~/assets/images/theme2/backdrop-3.svg"
          class="invisible lg:visible absolute left-0 bottom-0 -z-10" alt="bc-3">
        <img class="absolute bottom-0 lg:-bottom-10 z-10 w-screen translate-y-1 lg:translate-y-20"
          src="~/assets/images/theme2/wave-blue.svg" alt="">

        <div v-for="(event, index) in wedding.events" :id="event.name" :key="index"
          class="w-4/5 lg:w-full mx-auto flex flex-col justify-center items-center text-center mb-14 gap-5"
          style="color: #314260;">
          <h1 class="italic text-3xl lg:text-6xl font-semibold" style="color: #D0A464" data-aos="fade-down"
            data-aos-duration="500">{{ event.name }}</h1>
          <span class="w-1/5 lg:w-20 border-b-4 rounded-full mb-5" style="border-color:#D0A464" data-aos="fade-down"
            data-aos-duration="500"></span>
          <div class="text-xl lg:text-2xl font-semibold" style="color: #314260" data-aos="fade-left"
            data-aos-duration="500">
            <div>{{ $moment(event.date).format('dddd[,] DD MMMM YYYY') }}</div>
            <div>Pukul {{ $moment(event.date).format('LT') }}</div>
          </div>
          <span class="w-1/5 lg:w-20 border-b-4 rounded-full mb-5" style="border-color:#D0A464" data-aos="fade-down"
            data-aos-duration="500"></span>
          <div class="flex flex-col items-center" data-aos="fade-down" data-aos-duration="500">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.5 1.13867C14.8869 1.13867 17.1761 2.08688 18.864 3.77471C20.5518 5.46254 21.5 7.75172 21.5 10.1387C21.5 13.8647 18.66 17.7687 13.1 21.9387C12.9269 22.0685 12.7164 22.1387 12.5 22.1387C12.2836 22.1387 12.0731 22.0685 11.9 21.9387C6.34 17.7687 3.5 13.8647 3.5 10.1387C3.5 7.75172 4.44821 5.46254 6.13604 3.77471C7.82387 2.08688 10.1131 1.13867 12.5 1.13867ZM12.5 7.13867C11.7044 7.13867 10.9413 7.45474 10.3787 8.01735C9.81607 8.57996 9.5 9.34302 9.5 10.1387C9.5 10.9343 9.81607 11.6974 10.3787 12.26C10.9413 12.8226 11.7044 13.1387 12.5 13.1387C13.2956 13.1387 14.0587 12.8226 14.6213 12.26C15.1839 11.6974 15.5 10.9343 15.5 10.1387C15.5 9.34302 15.1839 8.57996 14.6213 8.01735C14.0587 7.45474 13.2956 7.13867 12.5 7.13867Z"
                fill="#314260" />
            </svg>
            <div class="text-base lg:text-2xl font-bold">{{ event.address }}</div>
            <div class="text-xs lg:text-xl">{{ event.address_detail }}</div>
          </div>

          <a v-show="index === wedding.events.length - 1"
            class="flex gap-2 py-3 px-5 text-white text-base rounded-xl select-none" style="background-color: #314260;"
            :href="wedding.google_maps_link" target="_blank" data-aos="fade-down" data-aos-duration="500">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.5 1.13867C14.8869 1.13867 17.1761 2.08688 18.864 3.77471C20.5518 5.46254 21.5 7.75172 21.5 10.1387C21.5 13.8647 18.66 17.7687 13.1 21.9387C12.9269 22.0685 12.7164 22.1387 12.5 22.1387C12.2836 22.1387 12.0731 22.0685 11.9 21.9387C6.34 17.7687 3.5 13.8647 3.5 10.1387C3.5 7.75172 4.44821 5.46254 6.13604 3.77471C7.82387 2.08688 10.1131 1.13867 12.5 1.13867ZM12.5 7.13867C11.7044 7.13867 10.9413 7.45474 10.3787 8.01735C9.81607 8.57996 9.5 9.34302 9.5 10.1387C9.5 10.9343 9.81607 11.6974 10.3787 12.26C10.9413 12.8226 11.7044 13.1387 12.5 13.1387C13.2956 13.1387 14.0587 12.8226 14.6213 12.26C15.1839 11.6974 15.5 10.9343 15.5 10.1387C15.5 9.34302 15.1839 8.57996 14.6213 8.01735C14.0587 7.45474 13.2956 7.13867 12.5 7.13867Z"
                fill="#FFFFFF" />
            </svg>
            <span>Lihat Lokasi</span>
          </a>
        </div>

        <div id="time" class="w-full lg:w-4/5 mx-auto flex flex-col justify-center items-center text-center mb-14 z-10"
          style="color: #314260;" data-aos="fade-down" data-aos-duration="500">
          <h1 class="text-xl font-bold lg:text-4xl mb-6 uppercase">Counting down to the day</h1>
          <div class="text-5xl grid grid-cols-3 gap-5 lg:gap-10 items-center">
            <div class="p-3 lg:p-10">
              <div class="text-3xl lg:text-6xl mb-6">{{ countdownData.days }}</div>
              <div class="text-xl lg:text-3xl">Hari</div>
            </div>
            <div class="border-x-4 py-2 lg:py-10 px-10 lg:px-20" style="border-color: #D5E7E7">
              <div class="text-3xl lg:text-6xl mb-6">{{ countdownData.hours }}</div>
              <div class="text-xl lg:text-3xl">Jam</div>
            </div>
            <div class="p-3 lg:p-10">
              <div class="text-3xl lg:text-6xl mb-6">{{ countdownData.minutes }}</div>
              <div class="text-xl lg:text-3xl">Menit</div>
            </div>
          </div>
        </div>
      </div>
      <!-- event end -->

      <!-- prewedding gallery -->
      <div id="gallery" class="relative flex flex-col items-center justify-center p-3 lg:p-5"
        style="background-color: #314260;">
        <h1 class="text-center text-white font-fair italic font-bold text-2xl lg:text-4xl" data-aos="fade-down"
          data-aos-duration="500">Prewedding Gallery</h1>
        <div v-if="wedding.gallery" id="gallery" v-viewer="propsViewer"
          class="flex flex-row w-full gap-3 my-10 overflow-x-auto lg:justify-center lg:w-5/6 lg:flex-wrap pb-10">
          <img v-for="(image, i) in wedding.gallery" :id="`image-${i}`" :key="i" v-lazy-load :src="image.url" alt=""
            class="rounded-sm cursor-pointer max-h-60 bg-gray-400" data-aos="zoom-in" data-aos-duration="500" />
        </div>
        <img v-lazy-load class="absolute bottom-0 lg:-bottom-10 z-10 w-screen translate-y-3 lg:translate-y-28"
          src="~/assets/images/theme2/wave-white.svg" alt="">
      </div>
      <!-- prewedding gallery end -->

      <!-- rsvp -->
      <div v-if="wedding.guests[0]" class="mt-24 lg:mt-48 relative min-h-max overflow-hidden pb-5 lg:pb-10 font-fair">
        <div class="text-center mb-10 px-5 lg:px-0">
          <h1 class="font-bold italic text-2xl lg:text-4xl font-fair mb-3" style="color: #314260;">RSVP</h1>
          <span class="font-fair text-base lg:text-xl"> <i class="text-red-500">*</i> Diharapkan Kepada Tamu Undangan
            Untuk Mengisi Form Kehadiran Dibawah Ini</span>
        </div>
        <img v-lazy-load src="~/assets/images/theme2/backdrop-1.svg"
          class="w-2/4 lg:w-auto absolute left-0 top-0 rotate-180 -z-10" alt="bc-1">
        <img v-lazy-load src="~/assets/images/theme2/backdrop-1.svg"
          class="w-2/4 lg:w-auto absolute right-0 bottom-0 -z-10" alt="bc-2">
        <rsvp-form :attendances="attendances" :guest="wedding.guests[0]" :wedding="wedding" class="pb-14 px-5 lg:px-0"
          @onGetAttendance="getAttendances" />
        <!-- rsvp end  -->

        <!-- filter -->
        <div v-if="wedding && wedding.setting && wedding.setting.ig_filter === false">
          <div class="flex flex-col items-center justify-center" data-aos="zoom-in-up">
            <h1 class="font-bold italic text-2xl lg:text-4xl font-fair mb-3" style="color: #314260;">CAPTURE YOUR
              MOMENTS
            </h1>
            <span class="font-fair text-base lg:text-xl">Use official filter to capture your moments</span>
            <span class="block h-1 my-4 text-center border-2rounded-md w-36" style="border-color:#D0A464"></span>
          </div>

          <div class="flex justify-center">
            <div
              class="flex flex-row max-w-fit px-10 lg:px-16 gap-8 my-5 overflow-x-auto lg:justify-center lg:w-5/6 lg:flex-wrap items-center relative"
              style="height: 500px">
              <img id="filter-1" src="@/assets/images/theme2/filter-1.webp" alt=""
                class="img rounded-sm cursor-pointer h-96 lg:h-96" data-aos="fade-down" data-aos-duration="500" />
            </div>
          </div>

          <div class="mt-3 justify-center flex mb-5">
            <a class="py-3 px-5 text-white text-base rounded-xl select-none" style="background-color: #314260;"
              href="https://www.instagram.com/ar/2271965836288555" target="_blank" data-aos="fade-down"
              data-aos-duration="500">
              <span>Get Filter</span>
            </a>
          </div>
        </div>
        <img v-lazy-load src="~/assets/images/theme2/wave-small-blue.svg"
          class="absolute right-0 left-0 -bottom-2 lg:bottom-0" style="min-width: -webkit-fill-available;" alt="bc-3">
      </div>
      <!-- filter end -->

      <div id="thankyou" class="text-white pt-24" style="background-color: #314260; max-width:-webkit-fill-available;">
        <h1 class="font-fair font-bold italic text-2xl lg:text-4xl text-center mb-5" data-aos="fade-down"
          data-aos-duration="500">Terima Kasih</h1>
        <p class="text-center mb-10 font-fair" data-aos="fade-down" data-aos-duration="500">Merupakan suatu kebahagiaan
          dan kehormatan bagi kami, apabila Bapak/Ibu/Saudara/i, berkenan hadir dan memberikan do’a restu kepada Kami.
        </p>
        <div class="h-96 w-screen overflow-hidden relative scroll-smooth" data-aos="fade-left" data-aos-duration="500">
          <div v-if="infiniteGallery" class="scroll-element primary flex flex-nowrap">
            <img v-for="(image, i) in infiniteGallery" :id="`image-${i}`" :key="i" v-lazy-load :src="image.url" alt=""
              class="rounded-md cursor-pointer max-h-60 mr-5" />
          </div>
        </div>
      </div>

      <footer id="footer" class="justify-center py-5 text-sm text-white font-fair" style="background-color: #314260">
        <div
          class="flex flex-col-reverse items-center justify-between w-full gap-3 mx-auto lg:flex-row lg:w-1/5 xl:w-1/5">
          <a href="https://bellioo.com/id" target="_blank">
            Bellioo &#169; {{ $moment().format('YYYY') }}.
          </a>

          <div class="flex flex-row gap-3">
            <a href="https://www.twitter.com/andriarfazzan/" class="cursor-pointer" target="_blank">
              <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M23.6428 2.43718C22.8078 2.80718 21.9108 3.05718 20.9678 3.17018C21.9408 2.58797 22.6687 1.67164 23.0158 0.592176C22.1016 1.13517 21.1011 1.51737 20.0578 1.72218C19.3561 0.973041 18.4268 0.476502 17.4141 0.30965C16.4014 0.142798 15.3619 0.314968 14.457 0.799429C13.5521 1.28389 12.8325 2.05354 12.4099 2.98888C11.9873 3.92422 11.8853 4.97293 12.1198 5.97218C10.2675 5.87917 8.4554 5.39773 6.80119 4.55908C5.14699 3.72044 3.68761 2.54334 2.51777 1.10418C2.11777 1.79418 1.88777 2.59418 1.88777 3.44618C1.88732 4.21317 2.0762 4.96842 2.43765 5.64491C2.79909 6.3214 3.32193 6.89821 3.95977 7.32418C3.22004 7.30064 2.49664 7.10076 1.84977 6.74118V6.80118C1.84969 7.87692 2.2218 8.91955 2.90295 9.75217C3.5841 10.5848 4.53234 11.1561 5.58677 11.3692C4.90055 11.5549 4.18111 11.5822 3.48277 11.4492C3.78026 12.3748 4.35976 13.1842 5.14013 13.7641C5.92051 14.344 6.86268 14.6654 7.83477 14.6832C6.1846 15.9786 4.14665 16.6813 2.04877 16.6782C1.67715 16.6783 1.30584 16.6566 0.936768 16.6132C3.06624 17.9824 5.54511 18.709 8.07677 18.7062C16.6468 18.7062 21.3318 11.6082 21.3318 5.45218C21.3318 5.25218 21.3268 5.05018 21.3178 4.85018C22.2291 4.19115 23.0157 3.37507 23.6408 2.44018L23.6428 2.43718Z"
                  fill="white" />
              </svg>
            </a>

            <a href="https://www.instagram.com/bellioo.app/" class="cursor-pointer" target="_blank">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.465 1.566C8.638 1.512 9.012 1.5 12 1.5C14.988 1.5 15.362 1.513 16.534 1.566C17.706 1.619 18.506 1.806 19.206 2.077C19.939 2.354 20.604 2.787 21.154 3.347C21.714 3.896 22.146 4.56 22.422 5.294C22.694 5.994 22.88 6.794 22.934 7.964C22.988 9.139 23 9.513 23 12.5C23 15.488 22.987 15.862 22.934 17.035C22.881 18.205 22.694 19.005 22.422 19.705C22.146 20.4391 21.7133 21.1042 21.154 21.654C20.604 22.214 19.939 22.646 19.206 22.922C18.506 23.194 17.706 23.38 16.536 23.434C15.362 23.488 14.988 23.5 12 23.5C9.012 23.5 8.638 23.487 7.465 23.434C6.295 23.381 5.495 23.194 4.795 22.922C4.06092 22.646 3.39582 22.2133 2.846 21.654C2.28638 21.1047 1.85331 20.4399 1.577 19.706C1.306 19.006 1.12 18.206 1.066 17.036C1.012 15.861 1 15.487 1 12.5C1 9.512 1.013 9.138 1.066 7.966C1.119 6.794 1.306 5.994 1.577 5.294C1.85372 4.56008 2.28712 3.89531 2.847 3.346C3.39604 2.7865 4.06047 2.35344 4.794 2.077C5.494 1.806 6.294 1.62 7.464 1.566H7.465ZM16.445 3.546C15.285 3.493 14.937 3.482 12 3.482C9.063 3.482 8.715 3.493 7.555 3.546C6.482 3.595 5.9 3.774 5.512 3.925C4.999 4.125 4.632 4.362 4.247 4.747C3.88205 5.10205 3.60118 5.53428 3.425 6.012C3.274 6.4 3.095 6.982 3.046 8.055C2.993 9.215 2.982 9.563 2.982 12.5C2.982 15.437 2.993 15.785 3.046 16.945C3.095 18.018 3.274 18.6 3.425 18.988C3.601 19.465 3.882 19.898 4.247 20.253C4.602 20.618 5.035 20.899 5.512 21.075C5.9 21.226 6.482 21.405 7.555 21.454C8.715 21.507 9.062 21.518 12 21.518C14.938 21.518 15.285 21.507 16.445 21.454C17.518 21.405 18.1 21.226 18.488 21.075C19.001 20.875 19.368 20.638 19.753 20.253C20.118 19.898 20.399 19.465 20.575 18.988C20.726 18.6 20.905 18.018 20.954 16.945C21.007 15.785 21.018 15.437 21.018 12.5C21.018 9.563 21.007 9.215 20.954 8.055C20.905 6.982 20.726 6.4 20.575 6.012C20.375 5.499 20.138 5.132 19.753 4.747C19.3979 4.38207 18.9657 4.10121 18.488 3.925C18.1 3.774 17.518 3.595 16.445 3.546ZM10.595 15.891C11.3797 16.2176 12.2534 16.2617 13.0669 16.0157C13.8805 15.7697 14.5834 15.2489 15.0556 14.5422C15.5278 13.8356 15.7401 12.9869 15.656 12.1411C15.572 11.2953 15.197 10.505 14.595 9.905C14.2112 9.52148 13.7472 9.22781 13.2363 9.04515C12.7255 8.86248 12.1804 8.79536 11.6405 8.84862C11.1006 8.90187 10.5792 9.07418 10.1138 9.35313C9.64845 9.63208 9.25074 10.0107 8.9493 10.4619C8.64786 10.913 8.45019 11.4253 8.37052 11.962C8.29084 12.4986 8.33115 13.0463 8.48854 13.5655C8.64593 14.0847 8.91648 14.5626 9.28072 14.9647C9.64496 15.3668 10.0938 15.6832 10.595 15.891ZM8.002 8.502C8.52702 7.97697 9.15032 7.5605 9.8363 7.27636C10.5223 6.99222 11.2575 6.84597 12 6.84597C12.7425 6.84597 13.4777 6.99222 14.1637 7.27636C14.8497 7.5605 15.473 7.97697 15.998 8.502C16.523 9.02702 16.9395 9.65032 17.2236 10.3363C17.5078 11.0223 17.654 11.7575 17.654 12.5C17.654 13.2425 17.5078 13.9777 17.2236 14.6637C16.9395 15.3497 16.523 15.973 15.998 16.498C14.9377 17.5583 13.4995 18.154 12 18.154C10.5005 18.154 9.06234 17.5583 8.002 16.498C6.94166 15.4377 6.34597 13.9995 6.34597 12.5C6.34597 11.0005 6.94166 9.56234 8.002 8.502ZM18.908 7.688C19.0381 7.56527 19.1423 7.41768 19.2143 7.25397C19.2863 7.09027 19.3248 6.91377 19.3274 6.73493C19.33 6.55609 19.2967 6.37855 19.2295 6.21281C19.1622 6.04707 19.0624 5.89651 18.936 5.77004C18.8095 5.64357 18.6589 5.54376 18.4932 5.47652C18.3275 5.40928 18.1499 5.37598 17.9711 5.37858C17.7922 5.38119 17.6157 5.41965 17.452 5.4917C17.2883 5.56374 17.1407 5.6679 17.018 5.798C16.7793 6.05103 16.6486 6.38712 16.6537 6.73493C16.6588 7.08274 16.7992 7.41488 17.0452 7.66084C17.2911 7.90681 17.6233 8.04723 17.9711 8.0523C18.3189 8.05737 18.655 7.92669 18.908 7.688Z"
                  fill="white" />
              </svg>
            </a>
          </div>
        </div>
      </footer>

      <audio-player :url="wedding.songs[0].url" :is-playing="isPlaying" />
    </div>
  </div>
</template>

<script>
import AOS from 'aos'
import { getCountDown } from '~/common/helper/date'
import rsvpForm from '~/components/common/rsvpForm.vue'
import audioPlayer from '~/components/common/audioPlayer.vue'
import 'aos/dist/aos.css' // You can also use <link> for styles
export default {
  name: 'ThemeOne',
  components: { rsvpForm, audioPlayer },
  props: {
    wedding: {
      type: Object,
      require: true,
      default: () => { }
    }
  },
  data() {
    return {
      countdown: null,
      countdownData: {
        hours: '00',
        minutes: '00',
        seconds: '00',
      },
      attendances: [],
      isPlaying: false,
      propsViewer: {
        navbar: true,
        toolbar: true,
      }
    }
  },
  computed: {
    isGuestExists() {
      return this.wedding?.guests && this.wedding?.guests.length > 0
    },
    infiniteGallery() {
      if (this.wedding.gallery.length > 0 && this.wedding.gallery.length <= 30) {
        const infinity = this.wedding.gallery
        infinity.concat(this.wedding.gallery, this.wedding.gallery)
        return infinity.slice(0, 29)
      }
      return this.wedding.gallery
    }
  },
  beforeDestroy() {
    // delete interval
    if (this.countdown) clearInterval(this.countdown)
  },

  mounted() {
    AOS.init({ duration: 500 });

    if (this.wedding.wedding_date) {
      this.runCountDown()
    }

    this.getAttendances()

    this.$moment.updateLocale('id');
  },
  methods: {
    openInvitation() {

      const body = document.getElementById('body')
      body?.classList.remove('hidden')
      body?.scrollIntoView({ behavior: 'smooth' })

      AOS.refresh()

      this.isPlaying = true

      const cover = document.getElementById('cover')
      const addClass = ['-translate-y-full', 'transition', 'duration-1000']
      cover?.classList.add(...addClass)
      setInterval(() => cover?.classList.add('opacity-0'), 1000)
    },
    runCountDown() {
      this.countdown = setInterval(() => {
        const { days, minutes, hours, interval } = getCountDown(this.wedding?.events[0]?.date ?? this.wedding.wedding_date)

        this.countdownData = {
          days: days < 10 ? '0' + days : days,
          hours: hours < 10 ? '0' + hours : hours,
          minutes: minutes < 10 ? '0' + minutes : minutes,
        }
        if (interval < 0) {
          clearInterval(this.countdown)
        }
      }, 1000);
    },
    getAttendances() {
      const urlApi = `/api/v1/public/attendances?wedding_id=${this.wedding.id}`
      this.$axios.get(urlApi).then(({ data }) => {
        this.attendances = data.data
      }).catch(() => {
        //
      })
    }
  }
}
</script>


<style scoped>
.main-bg,
.person-cover,
.surah-cover {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
}

.surah-cover {
  /* background-image: url('~/assets/images/theme2/bg-shit.png'); */
  background-position: center !important;
}

.person-cover {
  background-position: start !important;
  min-height: max-content + 100px;
  height: 80vh;
  position: relative;
}

.person-cover::after {
  content: '';
  background-image: linear-gradient(0deg, rgba(0 0 0/ 60%), rgba(0 0 0/ 60%));
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.main-bg::after,
.surah-cover::after {
  content: '';
  background-image: linear-gradient(0deg, rgba(0 0 0/ 40%), rgba(0 0 0/ 40%));
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.scroll-element {
  width: inherit;
  height: inherit;
  position: absolute;
  left: 0%;
  top: 0%;
}

.primary {
  animation: primary 60s linear infinite;
}

.img:hover {
  animation: scale 0.5s ease both;
}

@keyframes scale {
  to {
    transform: scale(1.2);
  }
}

@keyframes primary {
  from {
    /* left: 0%; */
    transform: translate3d(0, 0, 0);
  }

  to {
    /* left: -100%; */
    transform: translate3d(-1624px, 0, 0);
  }
}

@media screen and (max-width: 480px) {
  .person-cover {
    background-repeat: no-repeat;
    background-size: contain;
    background-position-y: top;
    background-color: #151515;
  }
}
</style>